import styled from '@emotion/styled';

export const MainAboutStyledSection = styled.section`
  background-color: #fbf8f8;
  margin: 5rem 0;
  @media (max-width: 96.875rem) {
    margin: 2rem 0;
  }
`;
